import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200 flex-shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_5 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_7 = {
  key: 0,
  class: "bg-amber-50 rounded-xl p-4"
};
const _hoisted_8 = {
  key: 1,
  class: "bg-amber-50 rounded-xl p-4"
};
const _hoisted_9 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_10 = {
  key: 2,
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_11 = {
  class: "flex items-center gap-3"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
  class: "min-w-0 flex-1 text-sm text-slate-600 truncate"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  key: 0,
  class: "px-6 pb-4"
};
const _hoisted_16 = {
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl flex-shrink-0"
};
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
import { ref, reactive, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { createDefaultReferrerFranchiseeBind, createReferrerLakalaReceiver, updateReferrerLakalaReceiver, uploadCommissionLakalaFile } from '@/api/commission';
const AGREEMENT_MAX_FILE_SIZE = 5 * 1024 * 1024;
export default {
  __name: 'ReferrerLakalaFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    referrerId: {
      type: [Number, String],
      default: null
    },
    accountData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formRef = ref(null);
    const agreementFileInputRef = ref(null);
    const submitting = ref(false);
    const savedReceiver = ref(null);
    const saveCompleted = ref(false);
    const selectedAgreementFile = ref(null);
    const selectedAgreementFileName = ref('');
    const AGREEMENT_ALLOWED_EXTENSIONS = ['jpg', 'png', 'pdf'];
    const AGREEMENT_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

    // 是否是编辑模式
    const isEdit = computed(() => !!props.accountData);
    const requiresManualBankInfo = computed(() => formData.acctTypeCode === '57');
    const submitButtonText = computed(() => selectedAgreementFile.value ? '保存并发起绑定' : '保存');
    const submittingText = computed(() => selectedAgreementFile.value ? '保存并绑定中...' : '保存中...');

    // 表单数据
    const getInitialFormData = () => ({
      referrerId: null,
      receiverName: '',
      contactMobile: '',
      licenseNo: '',
      licenseName: '',
      legalPersonName: '',
      legalPersonCertificateType: '',
      legalPersonCertificateNo: '',
      acctNo: '',
      acctName: '',
      acctTypeCode: '',
      acctCertificateType: '',
      acctCertificateNo: '',
      acctOpenBankCode: '',
      acctOpenBankName: '',
      acctClearBankCode: ''
    });
    const formData = reactive(getInitialFormData());

    // 验证规则
    const rules = computed(() => {
      const baseRules = {
        receiverName: [{
          required: true,
          message: '请输入分账接收方名称',
          trigger: 'blur'
        }],
        contactMobile: [{
          required: true,
          message: '请输入联系手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        acctTypeCode: [{
          required: true,
          message: '请选择账户类型',
          trigger: 'change'
        }],
        acctName: [{
          required: true,
          message: '请输入收款账户名称',
          trigger: 'blur'
        }],
        acctNo: [{
          required: true,
          message: '请输入收款账户卡号',
          trigger: 'blur'
        }]
      };
      if (requiresManualBankInfo.value) {
        baseRules.acctOpenBankCode = [{
          required: true,
          message: '请输入开户行号',
          trigger: 'blur'
        }];
        baseRules.acctClearBankCode = [{
          required: true,
          message: '请输入清算行行号',
          trigger: 'blur'
        }];
        baseRules.acctOpenBankName = [{
          required: true,
          message: '请输入开户行名称',
          trigger: 'blur'
        }];
      }

      // 对公账户额外的验证
      if (formData.acctTypeCode === '57') {
        baseRules.licenseNo = [{
          required: true,
          message: '对公账户请输入营业执照号',
          trigger: 'blur'
        }];
        baseRules.licenseName = [{
          required: true,
          message: '对公账户请输入营业执照名称',
          trigger: 'blur'
        }];
        baseRules.legalPersonName = [{
          required: true,
          message: '对公账户请输入法人姓名',
          trigger: 'blur'
        }];
        baseRules.legalPersonCertificateType = [{
          required: true,
          message: '对公账户请选择法人证件类型',
          trigger: 'change'
        }];
        baseRules.legalPersonCertificateNo = [{
          required: true,
          message: '对公账户请输入法人证件号',
          trigger: 'blur'
        }];
      }
      return baseRules;
    });

    // 重置表单
    const resetForm = () => {
      savedReceiver.value = null;
      saveCompleted.value = false;
      clearAgreementFile();
      if (props.accountData) {
        // 编辑模式 - 填充已有数据
        Object.keys(getInitialFormData()).forEach(key => {
          let value = props.accountData[key] ?? getInitialFormData()[key];
          // API 返回的 acctTypeCode 可能是整数，需要转为字符串用于表单判断
          if (key === 'acctTypeCode' && value !== null && value !== undefined) {
            value = String(value);
          }
          formData[key] = value;
        });
      } else {
        // 新增模式
        const initial = getInitialFormData();
        Object.keys(initial).forEach(key => {
          formData[key] = initial[key];
        });
        formData.referrerId = props.referrerId;
      }
    };
    const clearAgreementFile = () => {
      selectedAgreementFile.value = null;
      selectedAgreementFileName.value = '';
      if (agreementFileInputRef.value) {
        agreementFileInputRef.value.value = '';
      }
    };
    const validateAgreementFile = file => {
      const extension = file.name?.split('.').pop()?.toLowerCase() || '';
      const extensionAllowed = AGREEMENT_ALLOWED_EXTENSIONS.includes(extension);
      const typeAllowed = !file.type || AGREEMENT_ALLOWED_TYPES.includes(file.type);
      if (!extensionAllowed || !typeAllowed) {
        ElMessage.error('合作协议仅支持 JPG、PNG、PDF 格式');
        return false;
      }
      if (file.size > AGREEMENT_MAX_FILE_SIZE) {
        ElMessage.error('合作协议文件大小不能超过 5M');
        return false;
      }
      return true;
    };
    const handleAgreementFileChange = event => {
      const file = event.target.files?.[0];
      if (!file) return;
      if (!validateAgreementFile(file)) {
        clearAgreementFile();
        return;
      }
      selectedAgreementFile.value = file;
      selectedAgreementFileName.value = file.name;
    };

    // 关闭弹窗
    const handleClose = () => {
      resetForm();
      emit('update:visible', false);
    };
    const handleContinueBind = () => {
      emit('success', {
        continueBind: true
      });
      handleClose();
    };
    const buildSubmitData = () => {
      const submitData = {
        ...formData,
        referrerId: props.referrerId ?? formData.referrerId,
        // 编辑时包含 id
        ...(isEdit.value ? {
          id: props.accountData.id
        } : {})
      };
      if (!requiresManualBankInfo.value) {
        delete submitData.acctOpenBankCode;
        delete submitData.acctOpenBankName;
        delete submitData.acctClearBankCode;
      }
      return submitData;
    };
    const uploadAgreementAndCreateBind = async submitData => {
      const formData = new FormData();
      formData.append('referrerId', submitData.referrerId);
      formData.append('attType', 'SPLIT_COOPERATION_FILE');
      formData.append('remark', '引入人与加盟商分账合作协议');
      formData.append('module', 'commission/referrer-bind');
      formData.append('file', selectedAgreementFile.value);
      const uploadedFile = await uploadCommissionLakalaFile(formData);
      await createDefaultReferrerFranchiseeBind(submitData.referrerId, {
        entrustFileName: uploadedFile.lakalaFileName,
        entrustFilePath: uploadedFile.lakalaFilePath
      });
    };

    // 提交表单
    const handleSubmit = async () => {
      try {
        await formRef.value.validate();
        const submitData = buildSubmitData();
        if (!isEdit.value && !submitData.referrerId) {
          ElMessage.error('缺少引入人ID，无法创建分账账户');
          return;
        }
        submitting.value = true;
        if (isEdit.value) {
          // 编辑模式
          await updateReferrerLakalaReceiver(submitData);
          ElMessage.success('更新成功');
          emit('success', {
            continueBind: false
          });
          handleClose();
        } else {
          // 新增模式
          await createReferrerLakalaReceiver(submitData);
          savedReceiver.value = submitData;
          saveCompleted.value = true;
          emit('success', {
            continueBind: false
          });
          if (selectedAgreementFile.value) {
            try {
              await uploadAgreementAndCreateBind(submitData);
              ElMessage.success('分账账户已创建，绑定申请已提交');
              handleClose();
            } catch (bindError) {
              console.error('创建后提交绑定申请失败:', bindError);
              ElMessage.warning(bindError.message || '分账账户已创建，绑定申请提交失败，可稍后在详情页重新绑定');
            }
          } else {
            ElMessage.success('创建成功');
          }
        }
      } catch (error) {
        console.error('保存分账账户失败:', error);
        if (error !== false) {
          ElMessage.error(error.message || '保存失败');
        }
      } finally {
        submitting.value = false;
      }
    };

    // 监听弹窗显示
    watch(() => props.visible, val => {
      if (val) {
        resetForm();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "3xl",
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(isEdit.value ? '编辑分账账户' : '创建分账账户'), 1), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: rules.value,
          "label-width": "120px",
          class: "space-y-6"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[17] || (_cache[17] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 基本信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "分账接收方",
            prop: "receiverName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.receiverName = $event),
              type: "text",
              placeholder: "请输入分账接收方名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.receiverName]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系手机",
            prop: "contactMobile"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.contactMobile = $event),
              type: "text",
              placeholder: "请输入联系电话",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.contactMobile]])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_5, [_cache[18] || (_cache[18] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          })]), _createTextVNode(" 收款账户信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "账户类型",
            prop: "acctTypeCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.acctTypeCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.acctTypeCode = $event),
              disabled: isEdit.value,
              placeholder: "请选择账户类型",
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "对公账户",
                value: "57"
              }), _createVNode(_component_el_option, {
                label: "对私账户",
                value: "58"
              })]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "收款账户名",
            prop: "acctName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.acctName = $event),
              type: "text",
              placeholder: "请输入收款账户名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctName]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "收款账号",
            prop: "acctNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.acctNo = $event),
              type: "text",
              placeholder: "请输入收款账户卡号",
              class: "form-input w-full font-mono"
            }, null, 512), [[_vModelText, formData.acctNo]])]),
            _: 1
          }), requiresManualBankInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_form_item, {
            label: "开户行号",
            prop: "acctOpenBankCode"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.acctOpenBankCode = $event),
              type: "text",
              placeholder: "请输入开户行号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctOpenBankCode]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "清算行行号",
            prop: "acctClearBankCode"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.acctClearBankCode = $event),
              type: "text",
              placeholder: "请输入清算行行号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctClearBankCode]])]),
            _: 1
          })])) : _createCommentVNode("", true), requiresManualBankInfo.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "开户行名称",
            prop: "acctOpenBankName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.acctOpenBankName = $event),
              type: "text",
              placeholder: "请输入开户行名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctOpenBankName]])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "账户证件类型",
            prop: "acctCertificateType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.acctCertificateType,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.acctCertificateType = $event),
              placeholder: "请选择证件类型",
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "身份证",
                value: "17"
              }), _createVNode(_component_el_option, {
                label: "护照",
                value: "18"
              }), _createVNode(_component_el_option, {
                label: "港澳居民来往内地通行证",
                value: "19"
              }), _createVNode(_component_el_option, {
                label: "台湾居民来往内地通行证",
                value: "20"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "账户证件号",
            prop: "acctCertificateNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.acctCertificateNo = $event),
              type: "text",
              placeholder: "请输入账户证件号",
              class: "form-input w-full font-mono"
            }, null, 512), [[_vModelText, formData.acctCertificateNo]])]),
            _: 1
          })]), formData.acctTypeCode === '57' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[19] || (_cache[19] = _createElementVNode("h4", {
            class: "text-sm font-medium text-amber-800 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })]), _createTextVNode(" 营业执照信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "营业执照号",
            prop: "licenseNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.licenseNo = $event),
              type: "text",
              placeholder: "请输入营业执照号码",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.licenseNo]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "营业执照名",
            prop: "licenseName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.licenseName = $event),
              type: "text",
              placeholder: "请输入营业执照名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.licenseName]])]),
            _: 1
          })])) : _createCommentVNode("", true), formData.acctTypeCode === '57' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[20] || (_cache[20] = _createElementVNode("h4", {
            class: "text-sm font-medium text-amber-800 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })]), _createTextVNode(" 法人信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "法人姓名",
            prop: "legalPersonName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.legalPersonName = $event),
              type: "text",
              placeholder: "请输入法人姓名",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.legalPersonName]])]),
            _: 1
          }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
            label: "法人证件类型",
            prop: "legalPersonCertificateType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.legalPersonCertificateType,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.legalPersonCertificateType = $event),
              placeholder: "请选择证件类型",
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "身份证",
                value: "17"
              }), _createVNode(_component_el_option, {
                label: "护照",
                value: "18"
              }), _createVNode(_component_el_option, {
                label: "港澳居民来往内地通行证",
                value: "19"
              }), _createVNode(_component_el_option, {
                label: "台湾居民来往内地通行证",
                value: "20"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人证件号",
            prop: "legalPersonCertificateNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formData.legalPersonCertificateNo = $event),
              type: "text",
              placeholder: "请输入法人证件号",
              class: "form-input w-full font-mono"
            }, null, 512), [[_vModelText, formData.legalPersonCertificateNo]])]),
            _: 1
          })])])) : _createCommentVNode("", true), !isEdit.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[21] || (_cache[21] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.586-6.586a4 4 0 10-5.657-5.657l-7.071 7.071a6 6 0 108.485 8.485L20.5 13"
          })]), _createTextVNode(" 合作协议（可选） ")], -1)), _createElementVNode("input", {
            ref_key: "agreementFileInputRef",
            ref: agreementFileInputRef,
            type: "file",
            accept: ".jpg,.png,.pdf",
            class: "hidden",
            onChange: handleAgreementFileChange
          }, null, 544), _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: submitting.value || saveCompleted.value,
            onClick: _cache[15] || (_cache[15] = $event => agreementFileInputRef.value?.click())
          }, " 选择文件 ", 8, _hoisted_12), _createElementVNode("div", _hoisted_13, _toDisplayString(selectedAgreementFileName.value || '未选择文件'), 1), selectedAgreementFile.value ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
            disabled: submitting.value || saveCompleted.value,
            onClick: clearAgreementFile
          }, " 移除 ", 8, _hoisted_14)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])]), saveCompleted.value && !isEdit.value && savedReceiver.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[22] || (_cache[22] = [_createElementVNode("div", {
          class: "rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800"
        }, " 分账账户已保存。可以现在上传合作协议并发起绑定，也可以稍后再绑定。 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [saveCompleted.value && !isEdit.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("button", {
          onClick: handleClose,
          class: "btn-secondary"
        }, " 稍后绑定 "), _createElementVNode("button", {
          onClick: handleContinueBind,
          class: "btn-primary"
        }, " 继续绑定 ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("button", {
          onClick: handleClose,
          class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSubmit,
          disabled: submitting.value,
          class: "btn-primary"
        }, [submitting.value ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(submittingText.value), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(submitButtonText.value), 1))], 8, _hoisted_17)], 64))])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};